export class Utils {
  
  
  public static isEmpty(obj: any): boolean {
    return obj == null ? true : (obj === '' ? true : false);
  }
  
  
  
  public static formatOptionValue(data) {
    var option = data.split(" ");
    if (option.length === 1) {
      option = option.join('');
      option = option.charAt(0).toUpperCase() + option.slice(1);
    }
    else {
      var arrTemp = [];
      option.forEach(element => {
        element = element.charAt(0).toUpperCase() + element.slice(1);
        arrTemp.push(element);
      });
      option = arrTemp.join(' ');
    }

    return option;
  }
  
  static isUndefined(value: any) {
    return typeof value === 'undefined';
  }

  
    static isEmptyValue(value: any) {
    return Utils.isUndefined(value) || value === '' || value === null;
  }
  

}
